module.exports = __webpack_public_path__ + "img/checkmark-blue-round-background.c44da5a4.svg";